﻿'use strict';

/**
 * @ngdoc service
 * @name ntmApp.ComplexSearchConstants
 * @description
 * # ComplexSearchConstants
 * Service in the ntmApp.
 */

angular.module('ntmApp')
  .factory('ComplexSearchConstants', function () {

      var constants = {};

      constants.ControlTypes = {          
          AUTOCOMPLETE: 'AUTOCOMPLETE',
          CHECKBOX: 'CHECKBOX',
          CHECKBOXLIST: 'CHECKBOXLIST',
          DATE: 'DATE',
          DROPLIST: 'DROPLIST',
          NUMERIC: 'NUMERIC',
          PICKLIST: 'PICKLIST',
          RADIO: 'RADIO',
          RADIOBOOLEAN: 'RADIOBOOLEAN',
          TEXT: 'TEXT'
      };

      constants.Operators = {
          CONTAINS: { value: 'contains', label: 'Contains' },
          EQUALS: { value: 'Equal', label: 'Equals' },
          NOT_EQUALS: { value: 'notEqualTo', label: 'Not equals' },
          STARTS_WITH: { value: 'StartWith', label: 'Starts with' },
          LESS_THAN: { value: 'lessThan', label: 'Less than' },
          LESS_THAN_OR_EQUAL: { value: 'lessThanOrEquals', label: 'Less than or equal' },
          GREATER_THAN: { value: 'greaterThan', label: 'Greater than' },
          GREATER_THAN_OR_EQUAL: { value: 'GreaterThanOrEquals', label: 'Greater than or equal' },
          BETWEEN: { value: 'between', label: 'Between' },
          TODAY: { value: 'TODAY', label: 'Today' },
          TOMORROW: { value: 'TOMORROW', label: 'Tomorrow' },
          THIS_WEEK: { value: 'THISWEEK', label: 'This week' },
          NEXT_WEEK: { value: 'NEXTWEEK', label: 'Next week' },
          THIS_MONTH: { value: 'THISMONTH', label: 'This month' },
          NEXT_MONTH: { value: 'NEXTMONTH', label: 'Next month' },
          MONTH_AFTER_NEXT: { value: 'MONTHAFTERNEXT', label: 'Month after next' },
          THIS_YEAR: { value: 'THIS_YEAR', label: 'This year' },
          YESTERDAY: { value: 'YESTERDAY', label: 'Yesterday' },
          LAST_WEEK: { value: 'LASTWEEK', label: 'Last week' },
          LAST_MONTH: { value: 'LASTMONTH', label: 'Last month' },
          LAST_YEAR: { value: 'LASTYEAR', label: 'Last year' },
          CURRENT_USDA_YEAR: { value: 'CURRENTUSDAYEAR', label: 'Current USDA year' },
          LAST_USDA_YEAR: { value: 'LASTUSDAYEAR', label: 'Last USDA year' },
          EMPTY: { value: 'EMPTY', label: 'Empty' },
          ISNULL: { value: 'isNull', label: 'IsNull' }
      };

      constants.OperatorsOfControlType = {

          hasOperators: function (type) {
              return type === constants.ControlTypes.NUMERIC || type === constants.ControlTypes.DATE;
          },

          getCalendarOperators: function () {
              return {
                  operators: [
                    constants.Operators.EQUALS,
                    constants.Operators.LESS_THAN_OR_EQUAL,
                    constants.Operators.GREATER_THAN_OR_EQUAL,
                    constants.Operators.BETWEEN
                  ],
                  defaultOperator: constants.Operators.EQUALS
              };
          },

          getOperators: function (type) {

              switch (type) {
                  case constants.ControlTypes.TEXT:
                      
                      return {
                          operators: [
                            constants.Operators.CONTAINS,
                            constants.Operators.EQUALS,
                            constants.Operators.STARTS_WITH
                          ],
                          defaultOperator: constants.Operators.CONTAINS
                      };

                  case constants.ControlTypes.NUMERIC:

                      return {
                          operators: [
                            constants.Operators.EQUALS,
                            constants.Operators.LESS_THAN,
                            constants.Operators.LESS_THAN_OR_EQUAL,
                            constants.Operators.GREATER_THAN,
                            constants.Operators.GREATER_THAN_OR_EQUAL,
                            constants.Operators.BETWEEN
                          ],
                          defaultOperator: constants.Operators.EQUALS
                      };

                  case constants.ControlTypes.PICKLIST:
                  case constants.ControlTypes.DROPLIST:
                  case constants.ControlTypes.RADIO:
                  case constants.ControlTypes.AUTOCOMPLETE:
                  case constants.ControlTypes.CHECKBOXLIST:

                      return {
                          operators: [
                            constants.Operators.EQUALS,
                            constants.Operators.NOT_EQUALS
                          ],
                          defaultOperator: constants.Operators.EQUALS
                      };

                  case constants.ControlTypes.DATE:

                      return {
                          operators: [
                            constants.Operators.EQUALS,
                            constants.Operators.LESS_THAN,
                            constants.Operators.LESS_THAN_OR_EQUAL,
                            constants.Operators.GREATER_THAN,
                            constants.Operators.GREATER_THAN_OR_EQUAL,
                            constants.Operators.BETWEEN,
                            constants.Operators.TODAY,
                            constants.Operators.TOMORROW,
                            constants.Operators.THIS_WEEK,
                            constants.Operators.NEXT_WEEK,
                            constants.Operators.THIS_MONTH,
                            constants.Operators.NEXT_MONTH,
                            constants.Operators.MONTH_AFTER_NEXT,
                            constants.Operators.THIS_YEAR,
                            constants.Operators.YESTERDAY,
                            constants.Operators.LAST_WEEK,
                            constants.Operators.LAST_MONTH,
                            constants.Operators.LAST_YEAR,
                            constants.Operators.CURRENT_USDA_YEAR,
                            constants.Operators.LAST_USDA_YEAR,
                            constants.Operators.EMPTY
                          ],
                          defaultOperator: constants.Operators.EQUALS
                      };

                  case constants.ControlTypes.RADIOBOOLEAN:

                      return {
                          operators: [
                          ],
                          defaultOperator: constants.Operators.EQUALS
                      };

                  default:
                      return [];
              }
          },

          getDateSpecificOperators: function() {
              return [
                  constants.Operators.TODAY,
                  constants.Operators.TOMORROW,
                  constants.Operators.THIS_WEEK,
                  constants.Operators.NEXT_WEEK,
                  constants.Operators.THIS_MONTH,
                  constants.Operators.NEXT_MONTH,
                  constants.Operators.MONTH_AFTER_NEXT,
                  constants.Operators.THIS_YEAR,
                  constants.Operators.YESTERDAY,
                  constants.Operators.LAST_WEEK,
                  constants.Operators.LAST_MONTH,
                  constants.Operators.LAST_YEAR,
                  constants.Operators.CURRENT_USDA_YEAR,
                  constants.Operators.LAST_USDA_YEAR,
                  constants.Operators.EMPTY
              ];
          },

          getDateSpecificRangeOperators: function () {
              return [
                  constants.Operators.THIS_WEEK,
                  constants.Operators.NEXT_WEEK,
                  constants.Operators.THIS_MONTH,
                  constants.Operators.NEXT_MONTH,
                  constants.Operators.MONTH_AFTER_NEXT,
                  constants.Operators.THIS_YEAR,
                  constants.Operators.LAST_WEEK,
                  constants.Operators.LAST_MONTH,
                  constants.Operators.LAST_YEAR,
                  constants.Operators.CURRENT_USDA_YEAR,
                  constants.Operators.LAST_USDA_YEAR
              ];
          },

          getDateSpecificSingleOperators: function () {
              return [
                  constants.Operators.TODAY,
                  constants.Operators.TOMORROW,
                  constants.Operators.YESTERDAY,
                  constants.Operators.EMPTY
              ];
          }
      };

      return constants;

  });